module.exports = __webpack_public_path__ + "static/media/ackbar.3f0ee26f.jpg";